import { Component, Inject, OnInit } from '@angular/core';

@Component({
  selector: 'app-base',
  template: '',
  styles: [],
})
export class BaseComponent implements OnInit {

  constructor(@Inject('title') title: string) {
    window.document.title = title;
  }

  ngOnInit(): void {

  }

}
